import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ViewDate from "../../../../Components/Masters/ViewDate";
import { useUser } from "../../../../context/AuthContext";

function formatDateDisplay(val) {
  if (!val) return "-";
  const s = String(val);
  if (s.length >= 10 && s[4] === "-") return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toISOString().slice(0, 10);
}

const SCOPE12_DEPENDENT_VIEW_FIELDS = new Set([
  "consolidationApproach",
  "portfolioBasisDateStart",
  "portfolioBasisDateEnd",
  "thresholdValue",
  "includeInScope3",
]);

function ViewInvestment({ inputData, data, viewData, setViewData, handleEdit }) {
  const { user } = useUser();
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (data) setFilteredData(data);
  }, [data]);

  const formatValue = (input, raw) => {
    if (raw === undefined || raw === null) return null;
    if (input.fieldName === "createdAt") return formatDateDisplay(raw);
    if (
      input.fieldName === "portfolioBasisDateStart" ||
      input.fieldName === "portfolioBasisDateEnd"
    ) {
      return formatDateDisplay(raw);
    }
    if (typeof raw === "boolean") return raw ? "Yes" : "No";
    return raw;
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.6rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() => setViewData(false)} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Investment Details
        </Typography>
        <Grid>
          <ViewDate data={data} />
        </Grid>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          {inputData.map((input) => {
            if (
              filteredData?.alreadyIncluded &&
              SCOPE12_DEPENDENT_VIEW_FIELDS.has(input.fieldName)
            ) {
              return null;
            }
            const value = formatValue(input, filteredData?.[input.fieldName]);
            if (value === undefined || value === null || value === "") return null;
            return (
              <Grid item xs={12} sm={12} key={input.fieldName}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {input.title}
                </Typography>
                <div>{value ?? "-"}</div>
              </Grid>
            );
          })}
        </Grid>

        {!user?.companyAdmin && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10%",
            }}
          >
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0a3f73", textTransform: "none" }}
              onClick={handleEdit}
            >
              Edit
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => setViewData(false)}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewInvestment;
